{
  "deals": {
    "common": {
      "cancel": "Annuler",
      "close": "Fermer",
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "systemError": "Erreur système. Veuillez réessayer plus tard.",
      "systemActor": "système",
      "notAssigned": "non assigné"
    },
    "page": {
      "heading": "Affaires"
    },
    "view": {
      "kanban": "Kanban",
      "list": "Liste"
    },
    "actions": {
      "newDeal": "Nouvelle affaire",
      "addProducts": "+ Ajouter des produits",
      "editProducts": "Modifier les produits",
      "pick": "Choisir",
      "createDeal": "Créer l'affaire"
    },
    "search": {
      "placeholder": "Rechercher par titre d'affaire ou lead/marchand"
    },
    "filters": {
      "allStages": "Toutes les étapes",
      "allSalers": "Tous les commerciaux"
    },
    "competitiveContextStub": "Contexte concurrentiel : vide (P12 en attente)",
    "fallback": {
      "untitled": "(sans titre)",
      "saler": "Commercial"
    },
    "pagination": {
      "summary": "Page {{page}} / {{pageCount}} ({{total}} affaires)",
      "prev": "Précédent",
      "next": "Suivant"
    },
    "columns": {
      "title": "Titre",
      "lead": "Lead / Marchand",
      "value": "Valeur",
      "stage": "Étape",
      "owner_saler": "Commercial",
      "expected_close_date": "Date de clôture",
      "probability_pct": "Probabilité",
      "last_activity_at": "Dernière activité"
    },
    "list": {
      "selectAllAria": "Sélectionner toutes les affaires visibles",
      "selectRowAria": "Sélectionner l'affaire {{title}}",
      "empty": "Aucune affaire ne correspond aux filtres actuels."
    },
    "stages": {
      "draft": "Brouillon",
      "pending_approval": "En attente d'approbation",
      "approved": "Approuvée",
      "sent": "Envoyée",
      "won": "Gagnée",
      "lost": "Perdue",
      "expired": "Expirée",
      "rejected": "Rejetée",
      "declined": "Refusée par le client"
    },
    "kanbanColumns": {
      "draft": "Prospection",
      "pending_approval": "Proposition",
      "approved": "Négociation",
      "sent": "Envoyée",
      "won": "Gagnée",
      "lost": "Perdue",
      "expired": "Expirée",
      "rejected": "Rejetée"
    },
    "kanban": {
      "closePrefix": "Clôture :",
      "daysInStage": "{{days}} j dans l'étape",
      "confirmStageTitle": "Confirmer le changement d'étape",
      "confirmStageBody": "Déplacer {{title}} de {{from}} vers {{to}} ?",
      "confirmBtn": "Confirmer",
      "configTooltip": "Configurer la carte",
      "configTitle": "Configurer la carte",
      "colorLabel": "Couleur de fond de la carte",
      "labelLabel": "Étiquette (tag)",
      "labelPlaceholder": "ex. Prioritaire, Chaud…",
      "colors": {
        "default": "Par défaut",
        "red": "Rouge",
        "amber": "Ambre",
        "green": "Vert",
        "blue": "Bleu",
        "purple": "Violet"
      }
    },
    "newModal": {
      "title": "Nouvelle affaire",
      "titleLabel": "Titre",
      "titlePlaceholder": "ex. Devis personnel T3 — Acme Corp",
      "leadLabel": "Lead",
      "leadPlaceholder": "Rechercher un lead par nom / email / société…",
      "salerLabel": "Commercial responsable",
      "salerPlaceholder": "Rechercher un commercial par nom / email…",
      "closeDateLabel": "Date de clôture prévue",
      "templateLabel": "Modèle",
      "templatePlaceholder": "(facultatif) rechercher un modèle…",
      "notesLabel": "Notes",
      "products": "Produits",
      "noProducts": "Aucun produit sélectionné — ouvrez le sélecteur pour ajouter des articles du catalogue.",
      "discountLabel": "Remise %",
      "taxLabel": "Taxe %",
      "grandTotal": "Total général"
    },
    "productPicker": {
      "title": "Ajouter des produits",
      "closeBackdropAria": "Fermer le sélecteur de produits",
      "dialogAria": "Sélecteur de produits",
      "searchPlaceholder": "Rechercher des produits par nom ou SKU",
      "searching": "Recherche…",
      "noMatch": "Aucun produit correspondant.",
      "startTyping": "Commencez à taper pour rechercher dans le catalogue.",
      "add": "+ Ajouter",
      "chooseVariant": "Choisir une variante pour {{name}}",
      "noProductsPicked": "Aucun produit sélectionné.",
      "colProduct": "Produit",
      "colQty": "Qté",
      "colUnitPrice": "Prix unitaire",
      "colLineTotal": "Total ligne",
      "skuPrefix": "SKU",
      "removeAria": "Supprimer {{name}}",
      "subtotal": "Sous-total :",
      "confirmOne": "Ajouter {{count}} produit",
      "confirmMany": "Ajouter {{count}} produits",
      "unknownError": "Erreur inconnue"
    },
    "approval": {
      "title": "Approuver l'affaire {{id}}",
      "description": "Le flux d'approbation suit des seuils de valeur. Manager/Admin peut approuver lorsque l'affaire est « En attente d'approbation ».",
      "name": "Nom :",
      "grandTotal": "Total général :",
      "discount": "Remise :",
      "tax": "Taxe :",
      "saler": "Commercial :",
      "requiredApprover": "Approbateur requis :",
      "slaText": "Temps restant avant l'escalade automatique vers l'Admin :",
      "slaEscalated": " (escaladé vers l'Admin)",
      "submitHeading": "Soumettre l'affaire au Manager/Admin pour approbation",
      "submit": "Soumettre pour approbation",
      "submitting": "Envoi…",
      "commentLabel": "Note d'approbation (facultatif — max 500 caractères)",
      "commentPlaceholder": "ex. OK à ce niveau de remise.",
      "approve": "Approuver",
      "approving": "Approbation…",
      "rejectLabel": "Motif de rejet (5–1000 caractères — obligatoire)",
      "rejectPlaceholder": "ex. Marge trop faible — veuillez ajuster la remise.",
      "reject": "Rejeter",
      "rejecting": "Rejet…",
      "reasonTooShort": "Veuillez saisir un motif (au moins 5 caractères).",
      "toast": {
        "submitSuccessTitle": "Demande d'approbation envoyée",
        "submitSuccessDesc": "L'affaire {{id}} est en attente d'approbation Manager/Admin.",
        "submitErrorTitle": "Impossible d'envoyer la demande",
        "approveSuccessTitle": "Affaire approuvée",
        "approveSuccessDesc": "L'affaire {{id}} a été approuvée.",
        "approveErrorTitle": "Impossible d'approuver",
        "rejectSuccessTitle": "Affaire rejetée",
        "rejectSuccessDesc": "L'affaire {{id}} a été rejetée. Le commercial peut soumettre une nouvelle version.",
        "rejectErrorTitle": "Impossible de rejeter"
      },
      "disabledReason": {
        "notPending": "La transaction est à l’étape {{stage}} — impossible d’approuver/rejeter.",
        "notApprover": "Seul un Manager ou un Admin peut approuver les transactions.",
        "missingPermission": "Votre compte n’a pas reçu l’autorisation crm:deals:approve.",
        "escalated": "Transaction de plus de 48 h — transférée à l’Admin pour approbation."
      },
      "sla": {
        "overdue": "en retard",
        "minutes": "{{m}} min",
        "hoursMinutes": "{{h}} h {{m}} min"
      }
    },
    "attachments": {
      "title": "Pièces jointes",
      "hint": ": max 25 Mo/fichier, 100 Mo/affaire. ClamAV analyse après le téléversement.",
      "quotaWarning": "Utilisé {{used}} / 100 Mo — proche de la limite de l'affaire.",
      "dropHint": "Glissez-déposez les fichiers ici ou cliquez sur le bouton de sélection.",
      "choose": "Choisir un fichier",
      "uploading": "Téléversement…",
      "empty": "Aucun fichier joint pour l'instant.",
      "download": "Télécharger",
      "delete": "Supprimer",
      "invalidFile": "Fichier invalide.",
      "scan": {
        "pending": "Analyse…",
        "clean": "Sain",
        "infected": "Infecté"
      },
      "toast": {
        "uploadedTitle": "Téléversé",
        "uploadedDesc": "{{filename}} est en cours d'analyse antivirus.",
        "uploadErrorTitle": "Échec du téléversement",
        "deletedTitle": "Fichier supprimé",
        "deletedDesc": "La pièce jointe a été retirée de l'affaire.",
        "deleteErrorTitle": "Impossible de supprimer"
      },
      "error": {
        "empty": "Le fichier est vide.",
        "tooLarge": "Le fichier dépasse 25 Mo.",
        "mime": "Le format {{type}} ne figure pas dans la liste blanche (PDF/DOC/XLS/JPG/PNG/ZIP).",
        "totalExceeded": "La taille totale des pièces jointes de la transaction dépasse 100 Mo."
      }
    },
    "send": {
      "title": "Envoyer le devis {{id}}",
      "description": "Rédigez l'email et (facultatif) joignez le PDF du devis. Le serveur applique DOMPurify au corps, priorité Resend → repli SES.",
      "toLabel": "Destinataires (À) — séparés par des virgules, 1–5 emails",
      "toPlaceholder": "marchand@example.com",
      "ccLabel": "CC — jusqu'à 5 (laisser vide si inutile)",
      "ccPlaceholder": "cc1@example.com, cc2@example.com",
      "subjectLabel": "Objet de l'email",
      "languageLabel": "Langue du devis",
      "bodyLabel": "Corps de l'email (HTML — sera traité par DOMPurify à l'envoi)",
      "attachPdf": "Joindre le PDF du devis de la version actuelle",
      "previewTitle": "Aperçu PDF",
      "generate": "Générer le PDF",
      "generating": "Génération…",
      "previewPlaceholder": "Cliquez sur « Générer le PDF » pour prévisualiser la version actuelle.",
      "iframeTitle": "Aperçu PDF",
      "send": "Envoyer le devis",
      "sending": "Envoi…",
      "invalidToList": "Liste d'emails invalide.",
      "invalidCcList": "Liste CC invalide.",
      "languages": {
        "en": "English (EN)",
        "vi": "Tiếng Việt (VI)",
        "fr": "Français (FR)"
      },
      "toast": {
        "pdfSuccessTitle": "PDF généré",
        "pdfSuccessDesc": "Aperçu à droite. Cliquez sur Envoyer pour transmettre au client.",
        "pdfErrorTitle": "Impossible de générer le PDF",
        "sentTitle": "Devis envoyé",
        "sentDesc": "Envoyé via {{provider}} le {{time}}.",
        "sendErrorTitle": "Impossible d'envoyer le devis"
      },
      "error": {
        "minEmails": "Au moins {{min}} e-mail requis.",
        "maxEmails": "Au maximum {{max}} e-mails.",
        "invalidEmail": "E-mail invalide : {{item}}"
      }
    },
    "compare": {
      "title": "Comparer les versions de l'affaire",
      "description": "Choisissez deux versions pour voir l'écart sur les lignes produit + remise + taxe + total.",
      "baseLabel": "Version de base (gauche)",
      "targetLabel": "Version comparée (droite)",
      "versionOption": "v{{version}} — {{date}}",
      "needBoth": "Sélectionnez deux versions valides pour voir les différences.",
      "identical": "Ces deux versions sont totalement identiques.",
      "summaryTitle": "Résumé des écarts",
      "discount": "Remise",
      "tax": "Taxe",
      "grandTotal": "Total général",
      "productsTitle": "Détail des produits",
      "skuPrefix": "SKU :",
      "before": "Avant",
      "after": "Après",
      "qtyPrefix": "Qté",
      "none": "Aucun",
      "status": {
        "added": "Ajouté",
        "removed": "Retiré",
        "changed": "Modifié",
        "unchanged": "Inchangé"
      }
    },
    "detail": {
      "missingId": "Identifiant d'affaire manquant.",
      "loading": "Chargement des détails de l'affaire…",
      "loadError": "Impossible de charger les données. Réessayez plus tard.",
      "back": "Retour à la liste des affaires",
      "tabsAria": "Sections de détail de l'affaire",
      "tabs": {
        "overview": "Aperçu",
        "versions": "Versions",
        "activity": "Activité",
        "documents": "Documents"
      },
      "header": {
        "approvalPrefix": "Approbation :",
        "lead": "Lead :",
        "saler": "Commercial :",
        "generateSend": "Générer & envoyer le devis",
        "sendEmail": "Envoyer un email",
        "approve": "Approuver l'affaire",
        "clone": "Dupliquer",
        "invalidateLink": "Invalider le lien public"
      },
      "toast": {
        "cloneSuccessTitle": "Affaire dupliquée",
        "cloneSuccessDesc": "Nouvelle affaire : {{id}}.",
        "cloneErrorTitle": "Impossible de dupliquer"
      },
      "overview": {
        "productsTitle": "Produits",
        "nonDraftNote": "L'affaire a quitté l'état Brouillon — elle ne peut être modifiée qu'en créant une nouvelle version (POST /versions).",
        "noProducts": "Aucun produit dans cette affaire pour l'instant.",
        "qty": "Qté",
        "unitPrice": "Prix unitaire",
        "lineTotal": "Total ligne",
        "skuPrefix": "SKU",
        "summaryTitle": "Récapitulatif",
        "subtotal": "Sous-total",
        "discountPct": "Remise %",
        "taxPct": "Taxe %",
        "discountLine": "Remise (-)",
        "taxLine": "Taxe (+)",
        "grandTotal": "Total général",
        "expiryLabel": "Date de clôture prévue (expiration)",
        "termsLabel": "Conditions",
        "notesLabel": "Notes internes",
        "save": "Enregistrer les modifications",
        "saveSuccessTitle": "Modifications enregistrées",
        "saveSuccessDesc": "L'affaire {{id}} a été mise à jour.",
        "saveErrorTitle": "Impossible d'enregistrer l'affaire"
      },
      "versions": {
        "title": "Versions ({{count}})",
        "compare": "Comparer les versions",
        "tooMany": ": l'affaire compte déjà {{count}} versions — envisagez de créer une nouvelle affaire plutôt que de continuer à réviser.",
        "empty": "L'affaire n'a pas encore de version snapshot. Une apparaîtra au premier lancement de « Générer le PDF ».",
        "linkRevoked": "Lien révoqué le {{date}}"
      },
      "activity": {
        "loading": "Chargement de l'activité…",
        "loadError": "Impossible de charger l'activité.",
        "title": "Activité",
        "subtitle": "Journal filtré sur l'affaire actuelle.",
        "empty": "Aucune activité enregistrée pour l'instant.",
        "actorPrefix": "Acteur :"
      },
      "documents": {
        "pdfTitle": "Devis PDF par version",
        "pdfSubtitle": "Chaque version snapshot a un PDF — les liens s'ouvrent dans un nouvel onglet.",
        "pdfEmpty": "Aucune version n'a encore été snapshotée.",
        "openPdf": "Ouvrir le PDF"
      },
      "conflict": {
        "title": "L'affaire a été modifiée",
        "description": "Un autre utilisateur vient de mettre à jour cette affaire. Veuillez recharger pour voir la dernière version avant d'enregistrer.",
        "dismiss": "Ignorer",
        "reload": "Recharger"
      },
      "invalidate": {
        "title": "Invalider le lien public",
        "description": "L'UUID du lien actuel renverra 410 Gone. Le système génère un nouvel UUID et enregistre l'activité.",
        "reasonLabel": "Motif (facultatif — affiché dans le journal d'activité)",
        "reasonPlaceholder": "ex. lien transféré involontairement",
        "successTitle": "Ancien lien invalidé",
        "successDesc": "Nouveau lien public : {{uuid}}",
        "processing": "Traitement…",
        "confirm": "Invalider le lien"
      }
    }
  },
  "quotationBlocks": {
    "header": {
      "primaryColor": "Couleur principale"
    },
    "footer": {
      "validityPlaceholder": "Devis valable jusqu'au {{deal.valid_until}} · Émis par {{deal.seller.name}}"
    },
    "terms": {
      "defaultPlaceholder": "Paiement sous 15 jours. Devis valable 30 jours. {{deal.notes}}"
    }
  },
  "leads": {
    "common": {
      "cancel": "Annuler",
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "close": "Fermer",
      "loading": "Chargement…",
      "actionSuccess": "Action réussie.",
      "systemError": "Erreur système. Veuillez réessayer plus tard.",
      "loadError": "Échec du chargement des données. Réessayez plus tard.",
      "empty": "(vide)",
      "none": "—"
    },
    "stages": {
      "new": "Nouveau",
      "contacted": "Contacté",
      "qualified": "Qualifié",
      "negotiation": "Négociation",
      "converted": "Converti",
      "lost": "Perdu",
      "archived": "Archivé"
    },
    "list": {
      "title": "Prospects",
      "viewKanban": "Kanban",
      "viewList": "Liste",
      "importCsv": "Importer CSV",
      "newLead": "Nouveau prospect",
      "searchPlaceholder": "Rechercher par nom / e-mail / société",
      "allStages": "Toutes les étapes",
      "allSalers": "Tous les commerciaux",
      "pageInfo": "Page {{page}} sur {{pageCount}} ({{total}} prospects)",
      "prev": "Précédent",
      "next": "Suivant"
    },
    "quickView": {
      "titleFallback": "Détails du prospect",
      "email": "E-mail",
      "company": "Société",
      "stage": "Étape",
      "label": "Étiquette",
      "tags": "Tags",
      "notes": "Notes",
      "notFound": "Prospect introuvable.",
      "openFull": "Ouvrir la page de détails"
    },
    "table": {
      "colName": "Nom",
      "colEmail": "E-mail",
      "colCompany": "Société",
      "colStage": "Étape",
      "colSaler": "Commercial",
      "colTags": "Tags",
      "selectAll": "Sélectionner tous les prospects",
      "selectOne": "Sélectionner {{name}}",
      "empty": "Aucun prospect."
    },
    "kanban": {
      "confirmTitle": "Confirmer le changement d'étape",
      "moveConfirm": "Déplacer \"{{name}}\" de {{from}} vers {{to}} ?",
      "confirm": "Confirmer",
      "cardConfigTitle": "Configuration de la carte",
      "cardBg": "Couleur de fond de la carte",
      "cardLabel": "Étiquette (tag)",
      "cardLabelPlaceholder": "ex. : Prioritaire, Chaud…",
      "colors": {
        "default": "Par défaut",
        "red": "Rouge",
        "amber": "Ambre",
        "green": "Vert",
        "blue": "Bleu",
        "purple": "Violet"
      }
    },
    "bulk": {
      "selected": "{{count}} sélectionné(s)",
      "reassign": "Réattribuer",
      "changeStage": "Changer d'étape",
      "delete": "Supprimer",
      "exportCsv": "Exporter CSV",
      "clear": "Effacer",
      "confirmDelete": "Supprimer {{count}} leads sélectionnés ?",
      "reassignTitle": "Réattribuer {{count}} leads à un seller",
      "changeStageTitle": "Changer l’étape de {{count}} leads",
      "stagePlaceholder": "Choisir une étape",
      "exportQueued": "Export CSV en cours — vous recevrez le fichier une fois terminé.",
      "actionFailed": "Échec de l'action groupée",
      "permissionHint": "Votre compte n'a pas la permission CRM requise pour cette action."
    },
    "csv": {
      "title": "Importer des prospects depuis un CSV",
      "fields": {
        "name": "Nom *",
        "email": "E-mail principal *",
        "phone": "Téléphone",
        "company": "Société",
        "source": "Source",
        "tags": "Tags"
      },
      "step1": "1. Téléversement",
      "step2": "2. Correspondance",
      "step3": "3. Aperçu",
      "step4": "4. Progression",
      "step5": "5. Rapport",
      "fileTooLarge": "Le fichier dépasse la limite de 10 Mo.",
      "selected": "Sélectionné : {{name}}",
      "dropzone": "Glissez un CSV ici ou cliquez pour parcourir",
      "uploadHint": "Max 10 Mo / 5 000 lignes. Colonnes requises : Nom + E-mail principal.",
      "mappingHint": "Faites correspondre les colonnes CSV → champs du prospect. Détection automatique si possible.",
      "skip": "— ignorer —",
      "progressNote": "Tâche d'import mise en file d'attente. La progression sera diffusée via WebSocket.",
      "reportComplete": "Import terminé.",
      "imported": "Importés : {{count}}",
      "skipped": "Ignorés (e-mail en double) : {{count}}",
      "errors": "Erreurs : {{count}}",
      "downloadErrorCsv": "Télécharger le CSV des erreurs",
      "next": "Suivant",
      "startImport": "Démarrer l'import",
      "done": "Terminé",
      "exportInProgress": "Export CSV en cours — vous recevrez le fichier une fois terminé.",
      "parseFailed": "Aucune colonne n'a pu être lue dans ce fichier. Enregistrez-le en CSV (séparé par virgule, point-virgule ou tabulation) puis réessayez — un classeur .xlsx doit d'abord être exporté en CSV.",
      "notCsvFile": "Seuls les fichiers .csv peuvent être importés. Dans Excel : Fichier → Enregistrer sous → CSV."
    },
    "create": {
      "title": "Créer un nouveau prospect",
      "subtitle": "Saisissez les informations du prospect. L'e-mail doit être unique.",
      "name": "Nom *",
      "emailPrimary": "E-mail principal *",
      "company": "Société",
      "source": "Source",
      "notes": "Notes",
      "sources": {
        "manual": "Saisie manuelle",
        "csv_import": "Import CSV",
        "auto_registration": "Auto-inscription",
        "referral": "Recommandation"
      },
      "creating": "Création...",
      "submit": "Créer le prospect",
      "errRequired": "Le nom et l'e-mail sont obligatoires",
      "errFail": "Échec de la création du prospect"
    },
    "activity": {
      "types": {
        "stage_change": "Changement d'étape",
        "note": "Note",
        "call": "Appel",
        "meeting": "Réunion",
        "email_sent": "E-mail envoyé",
        "email_clicked": "Clic sur e-mail",
        "version": "Version du devis",
        "approval": "Approbation du devis",
        "contacted": "Contacté",
        "attachment": "Pièce jointe",
        "quotation_sent": "Devis envoyé"
      },
      "regionAria": "Chronologie d'activité du prospect",
      "filterLabel": "Filtrer par type d'événement :",
      "clearFilter": "Effacer le filtre",
      "loading": "Chargement de l'activité…",
      "empty": "Aucune activité pour le moment.",
      "by": "Par : {{actor}}",
      "loadMore": "Voir plus ({{count}})",
      "subject": "Objet : {{subject}}",
      "manualTypes": {
        "note": "Note",
        "call": "Appel",
        "meeting": "Réunion"
      },
      "formType": "Type d'activité",
      "duration": "Durée (minutes)",
      "body": "Contenu",
      "bodyPlaceholder": "Résumez l'appel/la réunion ou une note interne…",
      "followup": "Suivi (follow-up)",
      "repeat": "Répéter",
      "occurrences": "Prochaines occurrences planifiées :",
      "saveActivity": "Enregistrer l'activité",
      "errBodyRequired": "Veuillez saisir le contenu (body) avant d'enregistrer.",
      "savedTitle": "Action réussie.",
      "savedDesc": "Nouvelle activité enregistrée dans la chronologie.",
      "saveFailTitle": "Impossible d'enregistrer l'activité",
      "rrulePresets": {
        "none": "Aucune répétition",
        "daily": "Quotidien",
        "weekly": "Hebdomadaire",
        "biweekly": "Toutes les deux semaines",
        "monthly": "Mensuel"
      }
    },
    "merge": {
      "title": "Fusionner les prospects en double",
      "description": "Le prospect actuel sera archivé (suppression logique) et toutes les activités / affaires / notes seront déplacées vers le prospect cible. L'e-mail principal du prospect cible est conservé.",
      "fields": {
        "name": "Nom",
        "company": "Société",
        "phones": "Numéros de téléphone",
        "tags": "Tags",
        "notes": "Notes",
        "custom_fields": "Champs personnalisés"
      },
      "targetIdLabel": "ID du prospect cible (sera conservé)",
      "targetIdPlaceholder": "lead_xxx ou friendly_id",
      "loadTarget": "Charger les données",
      "sameLeadError": "Impossible de fusionner un prospect avec lui-même.",
      "loadingTarget": "Chargement du prospect cible…",
      "targetNotFound": "Prospect cible introuvable.",
      "sourceCard": "Prospect source (sera archivé)",
      "targetCard": "Prospect cible (sera conservé)",
      "noConflict": "Aucun conflit de champ — toutes les activités / affaires / notes seront fusionnées dans le prospect cible, en conservant ses champs existants.",
      "conflictHint": "Champs en conflit — choisissez le côté à conserver :",
      "fieldPickerAria": "Sélecteur de champ",
      "colField": "Champ",
      "colSource": "Prospect source",
      "colTarget": "Prospect cible",
      "confirm": "Confirmer la fusion",
      "merging": "Fusion…",
      "selectTargetFirst": "Veuillez d'abord sélectionner un prospect cible.",
      "mergedDesc": "Prospect {{source}} fusionné dans {{target}}."
    },
    "detail": {
      "missingId": "ID du prospect manquant.",
      "loading": "Chargement des détails du prospect…",
      "back": "Retour à la liste des prospects",
      "tabs": {
        "info": "Infos",
        "activity": "Activité",
        "deals": "Affaires",
        "merchant": "Marchand",
        "files": "Fichiers"
      },
      "tabsAria": "Sections de détail du prospect",
      "company": "Société : {{company}}",
      "email": "E-mail : {{email}}",
      "phone": "Tél. : {{phones}}",
      "assignee": "Responsable :",
      "unassigned": "Non attribué",
      "convertBtn": "Convertir en marchand",
      "convertedBtn": "Converti",
      "mergeBtn": "Fusionner le prospect en double",
      "archiveBtn": "Archiver",
      "archivedBtn": "Archivé",
      "basicInfo": "Informations de base",
      "customFields": "Champs personnalisés",
      "customFieldsHint": "Saisissez sous forme d'objet JSON. Le serveur valide le schéma.",
      "fieldName": "Nom",
      "fieldStage": "Étape",
      "fieldAssignee": "Responsable",
      "assigneePlaceholder": "Trouver un commercial par nom / e-mail…",
      "fieldTags": "Tags (séparés par des virgules)",
      "tagsPlaceholder": "vip, q2-priority",
      "fieldNotes": "Notes internes",
      "saveChanges": "Enregistrer les modifications",
      "savedDesc": "Prospect {{id}} mis à jour.",
      "saveFailTitle": "Impossible d'enregistrer le prospect",
      "customFieldsInvalid": "custom_fields doit être un objet JSON.",
      "deals": {
        "loading": "Chargement des affaires…",
        "empty": "Ce prospect n'a encore aucune affaire liée.",
        "colDeal": "Affaire",
        "colStage": "Étape",
        "colValue": "Valeur",
        "colExpiry": "Expiration",
        "noTitle": "(sans titre)"
      },
      "files": {
        "loading": "Chargement des fichiers…",
        "empty": "Aucun fichier pour le moment. Les fichiers sont joints aux affaires liées à ce prospect.",
        "dealPrefix": "Affaire : {{deal}}",
        "fileFallback": "fichier"
      },
      "merchant": {
        "notConvertedTitle": "Non converti",
        "notConvertedDesc": "Ce prospect n'a pas été converti en marchand. Cliquez sur le bouton 'Convertir en marchand' dans la barre d'actions pour démarrer le flux d'onboarding.",
        "convertedTitle": "Marchand converti",
        "convertedBody": "Ce prospect a été converti en marchand",
        "openMerchant": "Ouvrir la page du marchand →"
      },
      "archive": {
        "title": "Archiver le prospect",
        "description": "Le prospect {{id}} sera archivé (suppression logique). Vous pouvez le restaurer depuis la page d'archives.",
        "archiving": "Archivage…"
      },
      "convert": {
        "title": "Convertir le prospect en marchand",
        "descWithEmail": "Le prospect {{id}} sera converti en marchand. Un compte de connexion sera créé et un e-mail d'invitation sera envoyé.",
        "descNoEmail": "Le prospect {{id}} sera converti en marchand. Un compte de connexion sera créé (aucun e-mail envoyé).",
        "descIneligible": "Le prospect {{id}} est à l'étape {{stage}}. La conversion n'est autorisée que lorsque l'étape est \"Qualifié\" ou \"Négociation\".",
        "sendEmail": "Envoyer l'e-mail d'invitation de connexion au nouveau marchand",
        "converting": "Conversion…",
        "confirm": "Convertir",
        "eligibilityError": "La conversion n'est autorisée que lorsque l'étape est \"Qualifié\" ou \"Négociation\".",
        "successTitle": "Converti en marchand",
        "successDesc": "Le marchand {{id}} a été créé.",
        "archiveSuccessDesc": "Prospect {{id}} archivé."
      }
    }
  },
  "settings": {
    "page": {
      "heading": "Paramètres de vente",
      "description": "Configurez le CRM pour tout le pipeline de vente — seuils d'approbation, champs personnalisés, raisons de perte, modèles de devis, digest admin, intégrations Lark / ICS.",
      "tablistAria": "Onglets des paramètres de vente"
    },
    "tabs": {
      "general": "Général",
      "customFields": "Champs personnalisés",
      "lossReasons": "Raisons de perte",
      "templates": "Modèles de devis",
      "digest": "Digest",
      "integrations": "Intégrations"
    },
    "common": {
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "undo": "Annuler",
      "add": "+ Ajouter",
      "adding": "Ajout…",
      "delete": "Supprimer",
      "setDefault": "Définir par défaut",
      "defaultBadge": "Par défaut",
      "saveFailed": "Échec de l'enregistrement",
      "setDefaultSuccess": "Défini par défaut",
      "setDefaultFailed": "Impossible de définir par défaut",
      "label": "Libellé",
      "enable": "Activer"
    },
    "general": {
      "validation": {
        "number": "Doit être un nombre",
        "integer": "Doit être un entier",
        "nonNegative": "Ne peut pas être négatif",
        "tooLarge": "Trop grand",
        "minDays": "Minimum 1 jour",
        "maxDays": "Maximum 90 jours"
      },
      "approval": {
        "title": "Seuils d'approbation",
        "description": "Seuils en USD (cents) qui acheminent automatiquement un devis vers le niveau d'approbation correspondant. Devis ≤ limite Seller → approbation automatique. Au-dessus de la limite Seller → Manager. Au-dessus de Manager → Admin.",
        "salerLimit": "Limite d'approbation automatique Seller (cents)",
        "managerLimit": "Limite Manager (cents)",
        "adminLimit": "Limite Admin (cents)"
      },
      "reminders": {
        "title": "Seuils de rappel et d'inactivité",
        "description": "Le nombre de jours de rappel d'inactivité d'un Lead correspond au nombre de jours sans activité avant l'envoi d'un rappel. Les seuils d'expiration de deal et de conversation inactive sont fixes selon CONTEXT.",
        "leadInactive": "Rappel d'inactivité du Lead (jours)"
      },
      "fixedInfo": {
        "dealExpiryLabel": "Rappel d'expiration du deal :",
        "dealExpiryBefore": "7 jours avant ",
        "dealExpiryAfter": "(fixe,).",
        "staleLabel": "Seuils de conversation inactive :",
        "staleValue": "3 j / 7 j / 14 j (fixe,)."
      },
      "saveSuccessTitle": "Enregistré",
      "saveSuccessDesc": "Les paramètres généraux ont été mis à jour.",
      "loading": "Chargement des paramètres généraux",
      "loadError": "Impossible de charger les paramètres généraux."
    },
    "customFields": {
      "loading": "Chargement des champs personnalisés",
      "loadError": "Impossible de charger les champs personnalisés.",
      "addedSuccess": "Champ personnalisé ajouté",
      "addFailed": "Impossible d'ajouter",
      "reorderSuccess": "Ordre mis à jour",
      "reorderFailed": "Impossible d'enregistrer l'ordre",
      "deletedSuccess": "Champ personnalisé supprimé",
      "deleteFailed": "Impossible de supprimer",
      "listTitle": "Champs personnalisés",
      "listDescription": "Gérez les champs personnalisés de l'entité Lead. Glissez-déposez pour réordonner (position d'affichage sur le formulaire Lead).",
      "empty": "Aucun champ personnalisé pour l'instant.",
      "dragTitle": "Glisser pour réordonner",
      "requiredBadge": "Obligatoire",
      "addTitle": "Ajouter un champ personnalisé",
      "addDescription": "Le champ apparaîtra sur le formulaire Lead à la position attribuée.",
      "labelPlaceholder": "ex. : Secteur",
      "typeLabel": "Type",
      "requiredCheckbox": "Obligatoire",
      "types": {
        "text": "Texte",
        "number": "Nombre",
        "dropdown": "Liste déroulante",
        "date": "Date",
        "checkbox": "Case à cocher"
      }
    },
    "digest": {
      "saveSuccess": "Planification du digest enregistrée",
      "loading": "Chargement de la config Digest",
      "loadError": "Impossible de charger la config Digest.",
      "cardTitle": "Digest admin",
      "cardDescription": "E-mail récapitulatif envoyé à l'Admin avec entonnoir + faits marquants gains/pertes. Choisissez une fréquence, ou désactivez si inutile.",
      "enableLabel": "Activer",
      "enableCheckbox": "Activer le digest admin",
      "cadenceLabel": "Fréquence",
      "cadence": {
        "dailyMorning": "Quotidien — 8h00 heure serveur",
        "weeklyMonday": "Hebdomadaire — lundi matin"
      }
    },
    "integrations": {
      "saveSuccess": "Intégrations enregistrées",
      "loading": "Chargement des Intégrations",
      "loadError": "Impossible de charger les Intégrations.",
      "validation": {
        "urlTooLong": "URL trop longue",
        "urlHttps": "L'URL du webhook doit commencer par https://"
      },
      "missingWebhookTitle": "URL de webhook manquante",
      "missingWebhookDesc": "Saisissez une URL de webhook avant de tester.",
      "testSuccessTitle": "Le webhook Lark fonctionne",
      "testSuccessDesc": "Réponse 2xx reçue de Lark.",
      "testFailedTitle": "Échec du test Lark",
      "lark": {
        "title": "Lark Bot",
        "description": "Envoyez des notifications CRM (nouveau lead, deal gagné, escalade) à un groupe Lark via webhook entrant. Testez avant d'activer.",
        "enableLabel": "Activer Lark Bot",
        "webhookLabel": "URL du webhook",
        "test": "Tester le webhook",
        "testing": "Envoi du test…"
      },
      "ics": {
        "title": "Export calendrier ICS",
        "description": "Une fois activé, chaque Seller reçoit une URL de flux ICS (abonnement par URL) pour importer les expirations de deal + rappels de lead dans le calendrier Google / Outlook.",
        "enableLabel": "Activer le flux ICS"
      }
    },
    "lossReasons": {
      "addedSuccess": "Raison de perte ajoutée",
      "addFailed": "Impossible d'ajouter",
      "reorderSuccess": "Ordre mis à jour",
      "reorderFailed": "Impossible d'enregistrer l'ordre",
      "actionFailed": "Échec de l'action",
      "loading": "Chargement des raisons de perte",
      "loadError": "Impossible de charger les raisons de perte.",
      "listTitle": "Raisons de perte",
      "listDescription": "Les raisons affichées dans la liste déroulante lors de la clôture d'un Lead en Perdu. Les valeurs par défaut (Budget / Concurrent / Sans réponse / Non qualifié / Autre) ne peuvent pas être supprimées — seulement archivées.",
      "empty": "Aucune raison de perte pour l'instant.",
      "defaultSeedBadge": "Valeur par défaut",
      "archivedBadge": "Archivé",
      "restore": "Restaurer",
      "archive": "Archiver",
      "addTitle": "Ajouter une raison de perte",
      "addDescription": "Une nouvelle raison apparaît en fin de liste ; utilisez le glisser-déposer pour la repositionner après création.",
      "labelPlaceholder": "ex. : Prix trop élevé"
    },
    "templates": {
      "deletedSuccess": "Modèle supprimé",
      "deleteFailed": "Impossible de supprimer",
      "loading": "Chargement des modèles de devis",
      "loadError": "Impossible de charger les modèles.",
      "title": "Modèles de devis",
      "description": "L'éditeur de blocs de chaque modèle se trouve sur sa propre page (task-55). Chaque locale (EN/VI/FR) peut avoir un modèle par défaut ; les devis créés depuis un Lead utilisent le modèle par défaut de la locale du Merchant.",
      "newTemplate": "+ Nouveau modèle",
      "empty": "Aucun modèle pour l'instant.",
      "deleteDefaultTooltip": "Définissez un autre modèle par défaut avant de supprimer."
    },
    "editor": {
      "saveSuccess": "Modèle enregistré",
      "saveFailed": "Impossible d'enregistrer le modèle",
      "previewFailed": "Erreur d'aperçu",
      "setDefaultSuccess": "Défini par défaut",
      "setDefaultFailed": "Impossible de définir par défaut",
      "loading": "Chargement du modèle",
      "loadError": "Impossible de charger le modèle.",
      "namePlaceholder": "Nom du modèle",
      "untitledTemplate": "Modèle sans titre",
      "rendering": "Rendu en cours…",
      "refreshPreview": "Actualiser l'aperçu",
      "setDefault": "Définir par défaut",
      "saving": "Enregistrement…",
      "save": "Enregistrer le modèle",
      "productTableTitle": "Tableau des produits",
      "productTableBody": "Rendu côté serveur à partir des deal items : SKU · Nom · Unité · Quantité · Prix unitaire · Montant. Mise en page fixe.",
      "summaryTitle": "Récapitulatif",
      "summaryTokensLabel": "Tokens injectés automatiquement :",
      "variablesTitle": "Variables",
      "variablesHelp": "Cliquez pour copier un token. Collez dans le champ Conditions / Pied de page.",
      "copiedTitle": "Token copié",
      "pdfPreviewTitle": "Aperçu PDF",
      "pdfPreviewSubtitle": "Deal d'exemple · actualisation auto à l'enregistrement",
      "iframeTitle": "Aperçu PDF du devis",
      "previewEmpty": "Cliquez sur « Actualiser l'aperçu » pour générer le PDF avec un deal d'exemple.",
      "conflictTitle": "Le modèle a été modifié",
      "conflictBody": "Un autre admin vient d'enregistrer ce modèle. Recharger pour voir le nouveau snapshot et réappliquer vos modifications ?",
      "close": "Fermer",
      "reload": "Recharger",
      "tokenDesc": {
        "leadFullName": "Nom complet du Lead",
        "leadCompany": "Société du Lead",
        "dealId": "ID du deal",
        "dealValue": "Valeur monétaire du deal",
        "dealValidUntil": "Date de validité du deal",
        "dealSalerName": "Nom complet du Seller",
        "dealNotes": "Notes spécifiques au deal",
        "productsTable": "Tableau de produits automatique",
        "subtotal": "Sous-total",
        "discount": "Montant de la remise",
        "tax": "Montant de la taxe",
        "total": "Total général"
      }
    }
  },
  "benefits": {
    "page": {
      "title": "Avantages marchands",
      "description": "Accordez des avantages aux marchands atteignant un palier de GMV.",
      "salerReadonly": "Le seller a un accès en lecture seule."
    },
    "tabs": {
      "pending": "En attente",
      "granted": "Accordés"
    },
    "table": {
      "merchant": "Marchand",
      "tier": "Palier",
      "benefitType": "Type d'avantage",
      "description": "Description",
      "status": "Statut",
      "action": "Action"
    },
    "actions": {
      "grant": "Accorder"
    },
    "status": {
      "pending": "En attente",
      "granted": "Accordé",
      "revoked": "Révoqué"
    },
    "benefitTypes": {
      "pricing_tier": "Palier tarifaire",
      "wallet_credit": "Crédit de portefeuille",
      "badge": "Badge",
      "custom": "Personnalisé"
    },
    "empty": {
      "pending": "Aucun marchand n'attend l'attribution d'un avantage.",
      "granted": "Aucun avantage n'a encore été accordé."
    },
    "loading": "Chargement des données…",
    "pagination": {
      "info": "Page {{page}} / {{pageCount}} ({{total}} avantages)",
      "prev": "Précédent",
      "next": "Suivant"
    },
    "toast": {
      "success": "Opération réussie."
    },
    "modal": {
      "title": "Accorder un avantage",
      "merchantLabel": "Marchand",
      "tierLabel": "Palier",
      "benefitTypeLabel": "Type d'avantage",
      "amountLabel": "Montant (cents)",
      "amountPlaceholder": "50000",
      "descriptionLabel": "Description ({{count}}/500)",
      "descriptionPlaceholder": "Remise Bronze avr. 2026",
      "expiresLabel": "Expiration (facultatif)",
      "cancel": "Annuler",
      "submit": "Accorder",
      "submitting": "Traitement…",
      "errors": {
        "description": "La description doit comporter entre 2 et 500 caractères.",
        "amount": "Le crédit de portefeuille requiert un montant (en cents) ≥ 1.",
        "invalidDate": "Date d'expiration invalide."
      }
    }
  },
  "groups": {
    "page": {
      "title": "Groupes de vendeurs",
      "description": "Gérer les groupes de vendeurs / responsables — hiérarchie à 2 niveaux."
    },
    "actions": {
      "create": "+ Créer un groupe",
      "view": "Voir",
      "edit": "Modifier",
      "assignSaler": "Affecter un vendeur",
      "addSubGroup": "+ Sous-groupe",
      "delete": "Supprimer"
    },
    "common": {
      "cancel": "Annuler"
    },
    "tree": {
      "empty": "Aucun groupe de vendeurs pour l'instant. Cliquez sur « Créer un groupe » pour commencer.",
      "level": "Niv {{level}}",
      "memberCount": "{{count}} membres",
      "subGroupCount": "{{count}} sous-groupe",
      "deleteBlockedChildren": "Suppression impossible : le groupe contient encore des sous-groupes.",
      "deleteBlockedMembers": "Suppression impossible : le groupe contient encore {{count}} membres.",
      "deleteTitle": "Supprimer le groupe"
    },
    "form": {
      "nameLabel": "Nom du groupe",
      "managerLabel": "Responsable",
      "managerPlaceholder": "Rechercher un responsable par nom ou e-mail…",
      "managerHint": "Laissez vide si aucun responsable n'est encore affecté.",
      "subGroupHint": "Créer un sous-groupe (niveau 2) sous le groupe parent :",
      "submitting": "Enregistrement…",
      "create": "Créer le groupe",
      "update": "Mettre à jour",
      "error": "Une erreur est survenue lors de l'enregistrement du groupe."
    },
    "dialog": {
      "createTitle": "Nouveau groupe",
      "editTitle": "Modifier le groupe"
    },
    "confirm": {
      "delete": "Supprimer le groupe « {{name}} » ?",
      "removeMember": "Retirer « {{name}} » du groupe « {{group}} » ?"
    },
    "assign": {
      "title": "Affecter un vendeur à « {{name}} »",
      "description": "Rechercher un vendeur par nom ou e-mail. : les leads existants restent dans l'ancienne équipe et doivent être réaffectés séparément.",
      "placeholder": "Rechercher un vendeur par nom / e-mail…",
      "submit": "Affecter"
    },
    "members": {
      "title": "Membres — {{name}}",
      "countLevel": "{{count}} membres · Niv {{level}}",
      "close": "Fermer",
      "loading": "Chargement…",
      "empty": "Le groupe n'a encore aucun membre.",
      "remove": "Retirer"
    },
    "loading": "Chargement des données…"
  },
  "merchants": {
    "list": {
      "title": "Marchands — Santé client",
      "subtitle": "Trié par score de santé croissant (critique en premier).",
      "searchPlaceholder": "Rechercher un marchand…",
      "healthFilterLabel": "Santé :",
      "tierFilterLabel": "Niveau KPI :",
      "loading": "Chargement des données…",
      "empty": "Aucun marchand ne correspond au filtre.",
      "selectRowAria": "Sélectionner {{name}}",
      "columns": {
        "merchant": "Marchand",
        "tier": "Niveau",
        "health": "Santé",
        "score": "Score",
        "lastOrder": "Dernière commande"
      },
      "bulk": {
        "selectedCount": "{{count}} marchand(s) sélectionné(s)",
        "clear": "Désélectionner",
        "grantBenefit": "Octroyer un avantage en masse",
        "grantBenefitTooltip": "Octroyer le même avantage à plusieurs marchands — voir le flux complet sur /admin/sales/benefits."
      }
    },
    "health": {
      "stateLabels": {
        "healthy": "En bonne santé",
        "at_risk": "À risque",
        "critical": "Critique",
        "churned": "Inactif"
      },
      "notComputedTooltip": "Score de santé non encore calculé. Le cron RFM s'exécute chaque nuit à 02:00 UTC.",
      "breakdown": "Détail : {{text}}",
      "weights": "Pondérations : R=40, F=30, M=20, E=10."
    },
    "tierLabels": {
      "bronze": "Bronze",
      "silver": "Argent",
      "gold": "Or",
      "platinum": "Platine"
    },
    "trendLabels": {
      "improving": "En amélioration",
      "declining": "En baisse",
      "stable": "Stable"
    },
    "drawer": {
      "close": "Fermer",
      "healthScoreLabel": "Score de santé :",
      "scoreComponents": "Composantes du score",
      "maxPoints": "max {{weight}} pts",
      "detailNote": "Le détail du score par composante + l'historique des commandes sont disponibles dans le profil complet.",
      "tier": "Niveau",
      "lastOrder": "Dernière commande",
      "scoreUpdated": "Score mis à jour",
      "viewFullProfile": "Voir le profil complet",
      "dimensions": {
        "R": "Recency (dernière commande)",
        "F": "Frequency (fréquence des commandes)",
        "M": "Monetary (GMV)",
        "E": "Engagement"
      }
    }
  },
  "reports": {
    "periods": {
      "week": "Semaine",
      "month": "Mois",
      "quarter": "Trimestre",
      "year": "Année"
    },
    "periodAria": "Période",
    "stageLabels": {
      "new": "Nouveau",
      "qualified": "Qualifié",
      "proposal": "Proposition",
      "negotiation": "Négociation",
      "closed_won": "Gagné",
      "closed_lost": "Perdu"
    },
    "filters": {
      "salerId": "ID du commercial",
      "groupId": "ID du groupe",
      "allPlaceholder": "(tous)"
    },
    "export": {
      "csv": "Exporter CSV",
      "excel": "Exporter Excel",
      "jobCreatedTitle": "Tâche {{format}} créée",
      "jobCreatedDesc": "Un e-mail sera envoyé une fois terminé (~{{seconds}}s).",
      "errorTitle": "Impossible de créer l'export"
    },
    "funnel": {
      "title": "Lead Funnel",
      "subtitle": "Répartition des leads par étape + taux de conversion entre les étapes.",
      "overallConversion": "Taux de conversion global",
      "stageCount": "Nombre d'étapes",
      "distributionByStage": "Répartition par étape",
      "chartEmpty": "Pas encore de données de funnel.",
      "tableEmpty": "Aucune donnée.",
      "columns": {
        "stage": "Étape",
        "count": "Nombre",
        "conversionNext": "% de conversion vers l'étape suivante"
      }
    },
    "winLoss": {
      "title": "Win / Loss",
      "subtitle": "Deals gagnés vs perdus dans le temps + taux de réussite + répartition des motifs de perte.",
      "winRate": "Taux de réussite",
      "won": "Gagnés",
      "lost": "Perdus",
      "chartTitle": "Gagnés vs Perdus",
      "chartEmpty": "Aucune donnée.",
      "wonLabel": "Gagnés",
      "lostLabel": "Perdus",
      "lossReasonsTitle": "Motifs de perte",
      "reasonsEmpty": "Aucun deal perdu sur cette période.",
      "columns": {
        "reason": "Motif",
        "dealCount": "Nombre de deals"
      }
    },
    "hub": {
      "title": "Sales Reports",
      "subtitle": "Rapports Funnel / Win-Loss / Pipeline / GMV. Cliquez sur une carte pour voir les détails.",
      "cardsAria": "Rapports",
      "pipelineSummaryAria": "Résumé du pipeline",
      "activePipeline": "Pipeline actif",
      "grandPipeline": "Pipeline total",
      "forecastWeighted": "Prévision (pondérée)",
      "chartEmpty": "Aucun deal actif."
    },
    "cards": {
      "funnel": {
        "label": "Lead Funnel",
        "description": "Répartition des leads par étape + % de conversion par étape."
      },
      "win-loss": {
        "label": "Win / Loss",
        "description": "Deals gagnés vs perdus dans le temps + taux de réussite."
      },
      "pipeline": {
        "label": "Pipeline",
        "description": "Sommes de valeur des deals actifs par étape + prévision (pondérée par probabilité)."
      },
      "gmv": {
        "label": "GMV",
        "description": "GMV par commercial / marchand / catégorie + export CSV."
      }
    }
  },
  "shared": {
    "autocomplete": {
      "placeholder": "Rechercher par nom / e-mail…",
      "searching": "Recherche…",
      "noResults": "Aucun résultat"
    },
    "userChip": {
      "unassigned": "Non attribué",
      "fallbackName": "Utilisateur {{idTail}}"
    }
  },
  "calendar": {
    "title": "Mon calendrier",
    "subtitle": "Relances + expirations d'affaires + devis envoyés. Cliquez sur « Reprogrammer » pour déplacer un événement.",
    "newFollowup": "+ Nouvelle relance",
    "viewModeAria": "Mode d'affichage",
    "gridAria": "Grille",
    "loadError": "Échec du chargement du calendrier.",
    "noEvents": "Aucun événement",
    "cancel": "Annuler",
    "views": {
      "week": "Semaine",
      "day": "Jour"
    },
    "eventKinds": {
      "follow_up": "Relance",
      "deal_expire": "Affaire expirant",
      "quotation_sent": "Devis envoyé"
    },
    "reschedule": {
      "title": "Reprogrammer",
      "dateTimeLabel": "Nouvelle date et heure",
      "saving": "Enregistrement…",
      "confirm": "Confirmer"
    },
    "create": {
      "title": "Nouvelle relance",
      "description": "Créez un nouveau prospect avec une échéance de contact — il apparaîtra sur le calendrier.",
      "nameLabel": "Nom *",
      "emailLabel": "E-mail *",
      "contactLabel": "Échéance de contact *",
      "creating": "Création…",
      "submit": "Créer"
    },
    "toast": {
      "createSuccess": "Relance créée",
      "createFailTitle": "Impossible de créer",
      "rescheduleSuccessTitle": "Reprogrammé",
      "rescheduleSuccessDesc": "L'événement a été reprogrammé.",
      "rescheduleFailTitle": "Impossible de reprogrammer",
      "invalidFormatTitle": "Format invalide",
      "invalidFormatDesc": "Veuillez choisir une date/heure valide."
    },
    "regenerate": {
      "create": "Générer une nouvelle URL ICS",
      "creating": "Génération…",
      "copyUrl": "Copier l'URL",
      "overlapNote": "L'ancienne URL reste valide jusqu'au {{date}}.",
      "toast": {
        "createdTitle": "Nouvelle URL générée",
        "createdDesc": "L'ancienne URL reste valide pendant 7 jours pour éviter toute interruption.",
        "createFailTitle": "Impossible de générer la nouvelle URL",
        "copiedTitle": "Copié",
        "copiedDesc": "La nouvelle URL ICS a été copiée.",
        "copyFailTitle": "Impossible de copier",
        "copyFailDesc": "Le navigateur a refusé l'accès au presse-papiers."
      }
    }
  },
  "gmvReport": {
    "title": "Rapport GMV",
    "subtitle": "GMV par seller / merchant / catégorie / période. Mis en cache 5 min (BE Redis).",
    "refresh": "Actualiser",
    "exportCsv": "Exporter CSV",
    "filtersAria": "Filtres",
    "chartTitle": "GMV {{group}}",
    "noDataRange": "Aucune donnée sur cette période.",
    "noData": "Aucune donnée.",
    "filters": {
      "dateFrom": "Date de début",
      "dateTo": "Date de fin",
      "groupBy": "Grouper par",
      "chart": "Graphique"
    },
    "groupBy": {
      "saler": "Par seller",
      "merchant": "Par merchant",
      "category": "Par catégorie",
      "day": "Par jour",
      "month": "Par mois"
    },
    "chartType": {
      "bar": "Barres",
      "line": "Courbe"
    },
    "kpi": {
      "gross": "GMV brut",
      "refunded": "Remboursé",
      "net": "GMV net"
    },
    "table": {
      "orders": "Commandes",
      "gross": "GMV brut",
      "refunded": "Remboursé",
      "net": "GMV net"
    },
    "toast": {
      "exportSuccessTitle": "Tâche d'export créée",
      "exportSuccessDesc": "Un e-mail sera envoyé une fois terminé (~{{seconds}}s).",
      "exportFailTitle": "Impossible de créer l'export"
    }
  },
  "leaderboard": {
    "title": "Classement des Sellers",
    "subtitle": "Top {{topN}} sellers par GMV. La vue matérialisée s'actualise toutes les 10 min ; les admins peuvent forcer l'actualisation (limite de 2 fois / 5 min).",
    "refreshNow": "Actualiser maintenant",
    "periodAria": "Période",
    "podiumAria": "Top 3",
    "podiumEmpty": "Aucune donnée pour cette période.",
    "gmv": "GMV",
    "dealsWon": "Affaires gagnées",
    "period": {
      "month": "Mois",
      "quarter": "Trimestre",
      "all_time": "Tout le temps"
    },
    "table": {
      "rank": "#",
      "saler": "Seller",
      "gmv": "GMV",
      "dealsWon": "Affaires gagnées",
      "empty": "Aucun seller au-delà du podium."
    },
    "toast": {
      "refreshSuccessTitle": "Classement actualisé",
      "refreshSuccessDesc": "{{count}} lignes mises à jour.",
      "refreshFailTitle": "Impossible d'actualiser"
    }
  },
  "myPerformance": {
    "heading": "Mes performances",
    "subtitle": "Suivez votre GMV personnel, vos objectifs et votre taux de conversion par période.",
    "loadError": "Échec du chargement des données.",
    "periodAria": "Période",
    "periods": {
      "monthly": "Ce mois-ci",
      "quarterly": "Ce trimestre",
      "semi": "Semestre",
      "annual": "Année"
    },
    "kpiAria": "KPI",
    "kpi": {
      "targetGmv": "GMV cible",
      "currentGmv": "GMV actuel",
      "progress": "Progression",
      "overallConversion": "Taux de conversion global"
    },
    "progress": {
      "aria": "Progression vs objectif",
      "title": "Progression vs objectif",
      "detail": "{{current}} / {{target}} (jusqu'au {{date}})",
      "empty": "Aucun objectif configuré pour cette période."
    },
    "funnel": {
      "aria": "Entonnoir de conversion",
      "title": "Entonnoir de conversion",
      "empty": "Aucune donnée d'entonnoir pour cette période."
    }
  },
  "myProfile": {
    "loading": "Chargement du profil",
    "loadError": "Impossible de charger le profil.",
    "heading": "Mon profil",
    "subtitle": "Vos coordonnées, votre signature e-mail et vos préférences de notification.",
    "validation": {
      "minChars": "Au moins {{count}} caractères",
      "maxChars": "Au plus {{count}} caractères",
      "invalidUrl": "URL invalide"
    },
    "toast": {
      "savedTitle": "Enregistré",
      "savedDesc": "Profil mis à jour.",
      "saveFailTitle": "Échec de l'enregistrement"
    },
    "basic": {
      "title": "Informations de base",
      "emailLabel": "E-mail",
      "emailNote": "ne peut pas être modifié ici — contactez l'admin si nécessaire.",
      "name": "Nom complet",
      "phone": "Numéro de téléphone",
      "phonePlaceholder": "+84 ...",
      "avatarUrl": "URL de l'avatar",
      "avatarHelp": "PNG/JPG, jusqu'à 2 Mo. FileUploadInput arrivera dans une prochaine vague ; collez l'URL directement pour l'instant.",
      "signatureLabel": "Signature e-mail (jusqu'à {{count}} caractères)",
      "signatureHelpPrefix": "Utilisez ",
      "signatureHelpSuffix": " pour insérer automatiquement le nom de l'expéditeur."
    },
    "notifications": {
      "title": "Préférences de notification",
      "desc": "Les changements s'appliquent au prochain envoi.",
      "followUp": "Notification de rappel de suivi",
      "dealExpire": "Notification de deal bientôt expiré",
      "digestLabel": "Résumé périodique",
      "digest": {
        "off": "Désactivé",
        "daily": "Quotidien",
        "weekly": "Hebdomadaire"
      }
    },
    "ics": {
      "title": "Calendrier ICS",
      "desc": "Régénérez l'URL du calendrier ICS si vous suspectez une fuite. L'ancienne URL reste valide pendant 7 jours après la régénération."
    },
    "save": {
      "saving": "Enregistrement…",
      "submit": "Enregistrer les modifications"
    }
  },
  "overview": {
    "heading": "Vue d'ensemble des ventes",
    "subtitle": "Vue d'ensemble des leads, deals, objectifs et de l'activité du jour.",
    "loadError": "Échec du chargement des données.",
    "kpiAria": "KPI",
    "cards": {
      "leads-today": "Leads aujourd'hui",
      "deals-expiring": "Deals bientôt expirés",
      "target-progress": "Progression de l'objectif mensuel",
      "activity-today": "Activité aujourd'hui"
    },
    "leaderboard": {
      "aria": "Classement",
      "title": "Top 10 Salers",
      "periods": {
        "month": "Mois",
        "quarter": "Trimestre",
        "all_time": "Tout le temps"
      },
      "columns": {
        "rank": "Rang",
        "saler": "Saler",
        "gmv": "GMV",
        "dealsWon": "Deals gagnés"
      },
      "empty": "Aucune donnée de classement pour le moment."
    },
    "activity": {
      "aria": "Activité",
      "label": "Activité :",
      "loadError": "Échec du chargement des données d'activité.",
      "title": "Activité récente",
      "subtitle": "30 derniers jours — jusqu'à 50 événements.",
      "empty": "Aucune activité pour le moment."
    }
  },
  "targets": {
    "heading": "Seller KPI Targets",
    "subtitle": "Gérez les objectifs GMV par période — admin/manager peuvent créer et modifier en ligne.",
    "exportCsv": "Exporter CSV",
    "newTarget": "Nouvel objectif",
    "periodAria": "Période",
    "periods": {
      "all": "Tous",
      "monthly": "Mois",
      "quarterly": "Trimestre",
      "semi": "Semestre",
      "annual": "Année"
    },
    "columns": {
      "saler": "Seller",
      "period": "Période",
      "range": "Plage",
      "targetGmv": "GMV cible",
      "current": "Actuel",
      "achieved": "% Atteint"
    },
    "empty": "Aucun objectif pour cette période.",
    "rowActions": {
      "cancel": "Annuler",
      "save": "Enregistrer",
      "edit": "Modifier"
    },
    "toast": {
      "createdTitle": "Objectif créé",
      "createdDesc": "Objectif KPI enregistré avec succès.",
      "createFailTitle": "Échec de la création de l'objectif",
      "updatedTitle": "Objectif mis à jour",
      "updateFailTitle": "Échec de la mise à jour",
      "exportTitle": "Tâche d'export créée",
      "exportDesc": "Un e-mail sera envoyé à la fin (~{{eta}}s).",
      "exportFailTitle": "Échec de la création de l'export",
      "invalidValueTitle": "Valeur invalide",
      "invalidValueDesc": "L'objectif doit être un nombre positif."
    },
    "modal": {
      "aria": "Créer un nouvel objectif KPI",
      "title": "Créer un objectif KPI",
      "salerLabel": "Seller",
      "salerPlaceholder": "Rechercher un seller par nom / e-mail…",
      "periodLabel": "Période",
      "startLabel": "Début",
      "endLabel": "Fin",
      "gmvLabel": "GMV cible (USD)",
      "cancel": "Annuler",
      "create": "Créer"
    }
  }
}
